<template>
  <div>
    <el-input-number
      v-if="data.mask"
      v-model="submit_data[data.key]"
      v-mask="data.mask"
      size="default"
      v-bind="attrs"
      :placeholder="data.desc"
      @blur="onBlur"
      @focus="onFocus"
      @change="onChange"
    />

    <el-input-number
      v-if="data.mask === undefined"
      v-model="submit_data[data.key]"
      size="default"
      v-bind="attrs"
      :placeholder="data.desc"
      @blur="onBlur"
      @focus="onFocus"
      @change="onChange"
    />
  </div>
</template>
<script>
import Common from './js/Common';
import InputTextarea from './js/InputTextarea';

const Js = Common('sls-input');
Js.mixins = [InputTextarea];
export default Js;
</script>
<style scoped lang="less"></style>
